
import React, { useState } from 'react';
import { TreatmentSession } from '@/types/treatmentSession';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';

interface SessionNotesEditorProps {
  session: TreatmentSession;
  onSave: (notes: string) => void;
  onCancel: () => void;
}

const SessionNotesEditor: React.FC<SessionNotesEditorProps> = ({
  session,
  onSave,
  onCancel
}) => {
  const [notes, setNotes] = useState(session.doctorNotes || '');
  
  const handleSave = () => {
    onSave(notes);
  };
  
  return (
    <div className="space-y-4 py-4">
      <div className="space-y-2">
        <Label htmlFor="notes">Session Notes</Label>
        <Textarea
          id="notes"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Enter your clinical notes for this session..."
          className="min-h-[200px]"
        />
      </div>
      
      <div className="flex justify-end gap-2">
        <Button variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button onClick={handleSave}>
          Save Notes
        </Button>
      </div>
    </div>
  );
};

export default SessionNotesEditor;
